import {connect} from "react-redux";
import {Component} from "react";
import * as React from "react";
import {Field} from "redux-form";
import CustomCheckbox from "./CustomCheckbox";
import {Col, Row} from "reactstrap";

class CustomCheckboxField extends Component {

    renderField = field => {
        const {label} = this.props;
        const {onChange, value} = field.input;
        return <CustomCheckbox label={label} onChange={onChange} value={value} title={field.title} disabled={field.disabled}/>
    };

    render() {
        const {name, className, ...props} = this.props;
        return <Row className={`form-group${className ? ` ${className}` : ""}`}>
            <Col xs={12} sm={4}/>
            <Col xs={12} sm={8}><Field name={name} component={this.renderField} {...props} /></Col>
        </Row>;
    }
}

export default connect()(CustomCheckboxField);
